import ZoneUtils from '../../../../../Util/ZoneUtils'
import { formatDate } from '../../utils'

import { PLAN_STATUS_TYPE } from '../utils'

import Strings from '../Strings'

const strings = Strings()
const statuses = PLAN_STATUS_TYPE(strings)

const getOrganizationName = (organizations, organizationId) => {
  for (let organization of organizations) {
    if (organization.id === organizationId) {
      return organization.name
    }
  }
  return null
}

const getZoneName = (zonesHierarchy, site, zone) => {
  return ZoneUtils.getZoneName(zonesHierarchy, site, zone)
}

const splitGrades = grades => {
  return grades.map(grade => grade.name)
}

const splitWeights = (weights, grades) => {
  return grades.map(grade => {
    for (let weight of weights) {
      if (weight.gradeId === grade.id) {
        return weight.totalKg
      }
    }
    return null
  })
}

export const DOWNLOAD_HEADERS = grades => [
  strings.createdAt,
  strings.updatedAt,
  strings.organization,
  strings.site,
  strings.zone,
  strings.status,
  strings.harvestStartDate,
  strings.harvestEndDate,
  strings.produce,
  strings.variety,
  strings.currency,
  strings.targetPrice,
  strings.totalWeightKg,
  strings.weights,
  ...splitGrades(grades)
]

export const DOWNLOAD_VALUES = (item, organizations, zones, grades) => {
  return [
    formatDate(item.createdAt, 'D TT'),
    formatDate(item.updatedAt, 'D TT'),
    getOrganizationName(organizations, item.organizationId),
    getZoneName(zones, item.siteId),
    getZoneName(zones, item.siteId, item.zoneId),
    statuses[item.status],
    formatDate(item.harvestStartDate, 'D'),
    formatDate(item.harvestEndDate, 'D'),
    item.produce.name,
    item.variety.name,
    item.currency.code,
    item.targetPrice,
    item.totalWeight,
    ...splitWeights(item.weights, grades)
  ]
}
